import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

// Reuse Pagination components
export default function PaginationUI(props) {
  return (
    <div>
      <Stack spacing={2} className="first pt-3 pb-4">
        <Pagination
          // variant="outlined"
          shape="circular"
          color="primary"
          // defaultPage={1}
          count={props.pagelength}
          page={props.page + 1}
          onChange={props.handleChange}
          // renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
          // onChange={props.handleChange}
          sx={{
            position: "relative",
            bottom: 10,
            top: 10,
          }}
        />
      </Stack>
    </div>
  );
}
